
import TitleDescriptionUniversal from '@/components/portal/TitleDescriptionUniversal.vue';
import { actualUrl } from '@/api/instance';
import { getAuthorizationKeyForWebComponents } from '@/api/ssoAuthorization';
import { getLastPageNew, goToDashBoard } from '@/utils/redirectUtils';
import LazyLoadWebComponent from '@/components/lazyload/LazyLoadWebComponent.vue';
import { Component, Vue } from 'vue-property-decorator';
import { finishFlow, startFlow } from '@/api/flowSession';
import IconArrow from '@/components/icons/IconArrow.vue';

@Component({
  components: {
    TitleDescriptionUniversal,
    LazyLoadWebComponent,
    IconArrow,
  },
})
export default class CreditScorePage extends Vue {
  actualUrl = actualUrl();
  ssoKey = '';
  isShowErrorMessage = false;
  apps = [];
  timeOut = 0;
  isSubscribeSessionSharesActive = true;

  get authObject(): any {
    return JSON.stringify({
      email: this.$store.state.user.email,
      key: this.ssoKey,
    });
  }

  async goToPortal(): Promise<void> {
    await finishFlow();
    goToDashBoard('dashboard')
    // this.$router.push({ name: 'PortalPage' });
  }
  async getSsoKey(): Promise<any> {
    try {
      this.ssoKey = ((await getAuthorizationKeyForWebComponents()) as any).data;
    } catch (error) {
      this.isShowErrorMessage = true;
    }
  }

  async setValidFlow(): Promise<void> {
    if (getLastPageNew() === 'PortalPage') {
      this.$store.commit('flowStages/setCurrentFlowAndStage', { flowVersion: '207', pageName: this.$route.name });
      await startFlow('207')
    } else {
      this.$store.commit('flowStages/setCurrentFlowAndStage', { flowVersion: '206', pageName: this.$route.name });
    }
  }

  mounted(): void {
    this.getSsoKey();
    this.setValidFlow();
  }

  destroyed(): void {
    this.isSubscribeSessionSharesActive = false;
  }
}
